import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import CompleteReturnModal from '../../../../views/order/common/modal/CompleteReturnModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';
import {
  INVALID_MINIMUM_REFUND_AMOUNT_MESSAGE,
  INVALID_MAXIMUM_REFUND_AMOUNT_MESSAGE,
} from '../../../../constants/service/invalidMsg/orderInvalidMsg';

class CompleteReturnModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  추가 청구 비용
       */
      extraPrice: 0,
      /**
       *  판매자 환불 예상금액 책정 사유
       */
      memo: null,
      /**
       *  판매자 환불 예상금액
       */
      refundSellerAmount: this.props.data.totalPrice - this.props.data.returnDeliveryFee,
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'completeReturnModal',
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 반품 승인 하기
   */
  onSubmit = () => {
    const { form, data, completeOrderReturn } = this.props;
    const { orderItemId } = data;
    const { extraPrice, memo, refundSellerAmount } = this.state;

    form.validateFields((err) => {
      if (err) return;

      completeOrderReturn({
        orderItemId,
        extraPrice,
        memo,
        refundSellerAmount,
      });

      this.closeModal();
    });
  };

  /**
   *  판매자 환불 예정 금액처리하기
   */
  setRefundSellerAmount = (value) => {
    const { data, form } = this.props;
    const { totalPrice, returnDeliveryFee } = data;

    /**
     * 판매자 예상 환불 금액에 추가 청구 비용을 적용하기
     * 추가 청구비가 음수가 나오면 0 으로 보정한다.
     */
    const extraPrice = totalPrice - returnDeliveryFee - value < 0 ? 0 : totalPrice - returnDeliveryFee - value;

    this.setState(
      {
        refundSellerAmount: value,
        extraPrice,
        memo: this.state.memo,
      },
      () => {
        /**
         * 판매자 예상 환불 금액 유효성 체크하기
         */
        form.setFieldsValue({ refundSellerAmount: value });
        form.validateFields(['refundSellerAmount']);
      },
    );
  };

  /**
   * 판매자 예상 환불 금액 유효성 체크
   * 판매자 예상 환불 금액은 0원 이상,
   * 고객 결제 금액보다 클 수 없음
   */
  validRefundSellerAmount = (rule, value, callback) => {
    const { data } = this.props;
    const { totalPrice } = data;

    if (value < 0) {
      callback(INVALID_MINIMUM_REFUND_AMOUNT_MESSAGE);
    } else if (totalPrice < value) {
      callback(INVALID_MAXIMUM_REFUND_AMOUNT_MESSAGE);
    } else callback();
  };

  render() {
    const { form, isOpen, data, getOrderReturnAttachment } = this.props;

    return (
      <CompleteReturnModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        getOrderReturnAttachment={getOrderReturnAttachment}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
        setRefundSellerAmount={this.setRefundSellerAmount}
        validRefundSellerAmount={this.validRefundSellerAmount}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.completeReturnModal.isOpen,
    data: state.order.completeReturnModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  completeOrderReturn: orderActions.completeOrderReturn,
  getOrderReturnAttachment: orderActions.getOrderReturnAttachment,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(CompleteReturnModalContainer)));
